import styled from "styled-components";

const AddButton = styled.button`
  background: green;
  color: white;
  display: flex;
  width: 100%;
  outline: none;
  border: none;
  padding: 36px 14px 12px 14px;
  margin-top: -24px;
  font-size: 16px;
  border-radius: 0;
  cursor: pointer;
`;

export default AddButton;
